The date & time the candidate was associated with the position.
